import { SvgIcon, SvgIconProps } from '@mui/material';

const Icon = ({ sx, ...props }: SvgIconProps) => (
  <SvgIcon {...props} sx={{ width: 20, height: 20, fill: 'transparent', color: '#667085', ...sx }} viewBox="0 0 20 20">
    <g clipPath="url(#clip0_4743_30215)">
      <path
        d="M18.332 16.6641L18.332 3.33073C18.332 2.41025 17.5858 1.66406 16.6654 1.66406L13.332 1.66406C12.4116 1.66406 11.6654 2.41025 11.6654 3.33073L11.6654 16.6641C11.6654 17.5845 12.4116 18.3307 13.332 18.3307L16.6654 18.3307C17.5858 18.3307 18.332 17.5845 18.332 16.6641Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33203 16.6641L8.33203 3.33073C8.33203 2.41025 7.58584 1.66406 6.66536 1.66406L3.33203 1.66406C2.41156 1.66406 1.66536 2.41025 1.66536 3.33073L1.66536 16.6641C1.66536 17.5845 2.41156 18.3307 3.33203 18.3307L6.66536 18.3307C7.58584 18.3307 8.33203 17.5845 8.33203 16.6641Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4743_30215">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default Icon;
